import { useEffect, useRef } from 'react';
import { App } from 'antd';
import { useNavigate, useSearchParams } from 'react-router';
import { MARCA_DE_VERIFICADO } from './verificacao';

/**
 * "E-mail confirmado": o aviso que faltava na chegada.
 *
 * Quem clicava no link do e-mail entrava no app e **nada dizia que tinha dado
 * certo** - a Home aparecia como se a pessoa simplesmente tivesse entrado, e o
 * clique que ativou a conta não tinha resposta nenhuma.
 *
 * O aviso sai do endereço, não de estado guardado em lugar nenhum: o
 * `callbackURL` do e-mail traz a marca, e a chegada a transforma em mensagem e
 * a apaga da URL - senão ela sobreviveria ao F5 e ao link compartilhado, e a
 * pessoa leria "e-mail confirmado" toda vez que voltasse à mesma tela.
 */
export function useAvisoDeEmailConfirmado(): void {
  const { message } = App.useApp();
  const [busca] = useSearchParams();
  const navigate = useNavigate();
  const jaAvisou = useRef(false);

  const confirmado = busca.get(MARCA_DE_VERIFICADO) === '1';

  useEffect(() => {
    if (!confirmado || jaAvisou.current) return;
    jaAvisou.current = true;

    void message.success('E-mail confirmado. Sua conta está pronta.');

    const limpo = new URLSearchParams(window.location.search);
    limpo.delete(MARCA_DE_VERIFICADO);
    const query = limpo.toString();
    void navigate(`${window.location.pathname}${query ? `?${query}` : ''}`, { replace: true });
  }, [confirmado, message, navigate]);
}
